import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { InstrumentsQuery } from 'src/app/shared/state/instruments/instruments.query';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { LedgerAccountsQuery } from '../../../../features/accounting/ledger-accounts/state/ledger-accounts.query';

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbResolver implements Resolve<string> {
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<string> {
        return this.instrumentsQuery.isLoading$.pipe(
            // make sure instruments are loaded
            filter((loading) => !loading),
            take(1),
            switchMap((_) =>
                this.instrumentsQuery.selectInstrumentById$(
                    +route.params.companyInstrumentId ||
                        +route.params.instrumentId ||
                        +route.params.id
                )
            ),
            map((instrument) => instrument.decoratedInstrumentName || instrument.name)
        );
    }
    constructor(private instrumentsQuery: InstrumentsQuery) {}
}

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbLedgerAccountResolver implements Resolve<string> {
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<string> {
        return this.ledgerAccountsQuery.isLoading$.pipe(
            // make sure ledger accounts are loaded
            filter((loading) => !loading),
            take(1),
            switchMap((_) =>
                this.ledgerAccountsQuery.selectLedgerAccountsByFilter$({
                    accountNo: {
                        eq: +route.params.accountNumber
                    }
                })
            ),
            map((account) => `Account ${account[0]?.accountNo}`)
        );
    }

    constructor(private ledgerAccountsQuery: LedgerAccountsQuery) {}
}
